import { IMG_HOST } from "@/config/api";

export function jointFrameColorLensImg ({
  productId,
  num,
  name,
  imgHost = IMG_HOST()
}:{
    productId:number,
    num:number,
    name:string,
    imgHost?:string
}) {
  if (/^http/.test(name)) {
    return name;
  }
  return `${imgHost}/p/${productId}/frame/${num}-${name}`;
}